import SVGIconWrapper from "./SVGIconWrapper"

const IconEllipsis = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#000000"}
        style={props.style}
        viewBox="0 0 500 500"
        iconClass={`icon--ellipsis ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <circle cx="50" cy="250" r="50" /><circle cx="450" cy="250" r="50" /><circle cx="250" cy="250" r="50" />
    </SVGIconWrapper>
)

export default IconEllipsis